var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbouticon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 65,
    viewBox: "0 0 68 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    width: 68,
    height: 65,
    rx: 5,
    fill: "#022964"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24_6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.3333 23H43.7C43.8833 22.4834 44 21.9167 44 21.3334C44 18.5667 41.7667 16.3334 39 16.3334C37.25 16.3334 35.7333 17.2334 34.8333 18.5834L34 19.7L33.1667 18.5667C32.2667 17.2334 30.75 16.3334 29 16.3334C26.2333 16.3334 24 18.5667 24 21.3334C24 21.9167 24.1167 22.4834 24.3 23H20.6667C18.8167 23 17.35 24.4834 17.35 26.3334L17.3333 44.6667C17.3333 46.5167 18.8167 48 20.6667 48H47.3333C49.1833 48 50.6667 46.5167 50.6667 44.6667V26.3334C50.6667 24.4834 49.1833 23 47.3333 23ZM39 19.6667C39.9167 19.6667 40.6667 20.4167 40.6667 21.3334C40.6667 22.25 39.9167 23 39 23C38.0833 23 37.3333 22.25 37.3333 21.3334C37.3333 20.4167 38.0833 19.6667 39 19.6667ZM29 19.6667C29.9167 19.6667 30.6667 20.4167 30.6667 21.3334C30.6667 22.25 29.9167 23 29 23C28.0833 23 27.3333 22.25 27.3333 21.3334C27.3333 20.4167 28.0833 19.6667 29 19.6667ZM47.3333 44.6667H20.6667V41.3334H47.3333V44.6667ZM47.3333 36.3334H20.6667V26.3334H29.1333L25.6667 31.05L28.3667 33L34 25.3334L39.6333 33L42.3333 31.05L38.8667 26.3334H47.3333V36.3334Z",
    fill: "#022964"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24_6"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbouticon3);
export default __webpack_public_path__ + "static/media/abouticon3.0d3f2afaafd2a599deb54b5c1d9226bf.svg";
export { ForwardRef as ReactComponent };